const { getElements, getElement } = window.BAO.Utils

export class MultipackQuickbuy extends window.BAO.CustomElement() {
  constructor (isInitialLoad = true) {
    super()

    this.multipackProperties = getElement('[data-multipack-item-properties]', { context: this.closest('[data-product-multipack]') })
    this.productForm = getElement('bao-product-form', { context: this.closest('[data-product-multipack]') })
    this.addToCartButton = getElement('[data-product-add-to-cart]', { context: this.productForm })
    this.addToCartButtonText = getElement('[data-product-add-to-cart-text]', { context: this.addToCartButton })

    if (!this.productForm || !this.addToCartButton || !this.addToCartButtonText) return

    this.handleMultipack(isInitialLoad)
  }

  setupListeners () {
    super.setupListeners()

    document.addEventListener('qbVariantChange', this.handleMultipack.bind(this))
  }

  handleMultipack (isInitialLoad = false) {
    const multipackVariants = getElements('[data-multipack-variant]')
    const variants = []

    multipackVariants.forEach((variant) => {
      const variantValue = variant.dataset.multipackVariant

      const radioParent = variant.closest('quick-buy-variant-radios')
      if (!radioParent) return

      const data = JSON.parse(getElement("[data-quick-buy-variant-radios-el='data']", { context: radioParent })?.textContent)
      const foundValue = data.filter(variant => variant.option1 === variantValue)

      if (foundValue.length > 0) {
        variants.push(foundValue)
      } else {
        this.addToCartButton.disabled = true
        this.addToCartButtonText.innerText = window.theme.strings.soldOut
      }
    })

    const variantsFlatten = variants.flat()

    this.multipackProperties.value = variantsFlatten.map(variant => variant.id)

    // Always check availability, even on initial load
    this.handleMultipackAvailability(variantsFlatten)
  }

  handleMultipackAvailability (variantsFlatten) {
    const multipackVariantsNotAllAvailable = !!variantsFlatten.find(
      variant => !variant.available,
    )

    this.addToCartButton.disabled = multipackVariantsNotAllAvailable
    this.addToCartButtonText.innerText = multipackVariantsNotAllAvailable ? window.theme.strings.soldOut : window.theme.strings.addToCart
  }
}

if (!customElements.get('multi-pack-quickbuy')) {
  customElements.define('multi-pack-quickbuy', MultipackQuickbuy)
}
